import { render, staticRenderFns } from "./index-footer.vue?vue&type=template&id=14eecb5f&"
import script from "./index-footer.vue?vue&type=script&lang=js&"
export * from "./index-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports